import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models for M206 (出庫通知單)
// ============================================================

export interface FM140 {
  fm140_01: string;          // 出庫通知單號 (PK)
  fm140_11: string | null;   // 填單日期 (ISO string)
  fm140_12: string;          // 單據類別 (A/C/D/E)
  fm140_13: string;          // 收貨廠商
  fm140_14: number;          // 出庫總數量
  fm140_15: string;          // 回應單據號碼
  fm140_16: string;          // 出庫庫位
  fm140_17: string | null;   // 希望出庫日
  fm140_18: string;          // 使用訂單號碼
  fm140_19: number;          // 總項數
  fm140_20: string;          // 入庫庫位
  fm140_21: number;          // 憑證類別
  fm140_22: string;          // 幣別
  fm140_23: string;          // 客訴單號
  fm140_24: boolean;         // 計稅
  fm140_80: string;          // 核准狀態
  fm140_91: string;          // 填單人
  fm140_92: string | null;   // 存檔時間

  // Associations
  details?: FM141[];
}

export interface FM141 {
  fm141_01: string;          // FK->FM140_01
  fm141_02: number;          // 項次
  fm141_11: string;          // 批號
  fm141_12: string;          // 產品代號1
  fm141_121: string;         // 產品代號2
  fm141_13: string;          // 等級
  fm141_14: string;          // 出庫單位
  fm141_15: number;          // 單價
  fm141_16: number;          // 出庫數量
  fm141_17: number;          // 金額
  fm141_20: number;          // 單位換算率
  fm141_21: string;          // 單位代號
  fm141_221: string;         // 單位中文
  fm141_222: string;         // 單位英文
  fm141_23: number;          // 明細單價(D類型)
}

// ============================================================
// Request / Response types
// ============================================================

export interface M206ListResponse {
  data: FM140[];
  total: number;
  page: number;
  size: number;
}

export interface M206CreateRequest {
  fm140_11: string | null;   // 填單日期
  fm140_12: string;          // 單據類別
  fm140_13: string;          // 收貨廠商
  fm140_15: string;          // 回應單據號碼
  fm140_16: string;          // 出庫庫位
  fm140_17: string | null;   // 希望出庫日
  fm140_18: string;          // 使用訂單號碼
  fm140_20: string;          // 入庫庫位
  fm140_21: number;          // 憑證類別
  fm140_22: string;          // 幣別
  fm140_23: string;          // 客訴單號
  fm140_24: boolean;         // 計稅
  fm140_91: string;          // 填單人
  details: Partial<FM141>[];
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const outboundNoticeApi = {
  async list(page = 1, size = 20): Promise<M206ListResponse> {
    const res = await apiClient.get('/api/outbound-notice', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FM140> {
    const res = await apiClient.get(`/api/outbound-notice/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: M206CreateRequest): Promise<FM140> {
    const res = await apiClient.post('/api/outbound-notice', data);
    return res.data;
  },

  async update(id: string, data: M206CreateRequest): Promise<FM140> {
    const res = await apiClient.put(`/api/outbound-notice/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/outbound-notice/${encodeURIComponent(id)}`);
  },

  async search(keyword: string, page = 1, size = 20): Promise<M206ListResponse> {
    const res = await apiClient.get('/api/outbound-notice', { params: { keyword, page, size } });
    return res.data;
  },
};
